import { PlacementInstructionConfigs } from '../../shared/types/reklameMaster';
import { MessageBus } from '@podium/browser';
import { events } from '@schibsted-nmp/advertising-events';
import { getConfig } from '../config';

export function getType(index: number) {
    const config = getConfig();
    const hasContentMarketing = config?.contentMarketing?.length > 0;
    if (hasContentMarketing && index === 1) {
        return 'content-marketing';
    }

    return 'ast';
}

export function companionReadyPlacementListener(
    placementInstructionConfigs: PlacementInstructionConfigs,
) {
    if (!placementInstructionConfigs?.length) return;

    const messageBus = new MessageBus();

    messageBus.publish(
        events.COMPANION.channel,
        events.COMPANION.PODLET_READY.topic,
        {
            placementInstructionConfigs,
        },
    );
}
